/**
 * Хелпер для работы с атрибутами.
 */
import moment from 'moment'
import _ from 'lodash'
import './AttributeType'
import './AttributeOption'
import 'Util'

/**
 * Форматирует значение атрибута в ссответсвии с типом атрибута.
 *
 * @param {Object} attribute
 * @param {*} value
 * @returns {*}
 */
export function format(attribute, value) {
    if (value != null && value !== '') {
        //noinspection NodeModulesDependencies,ES6ModulesDependencies
        switch (_.parseInt(attribute.type)) {
            case Accounting.AttributeType.Datetime:
                value = moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm');
                break;
            case Accounting.AttributeType.Date:
                value = moment(value, 'YYYY-MM-DD').format('DD.MM.YYYY');
                break
        }
    }

    return value;
}

/**
 * Форматирует HTML значение атрибута в ссответсвии с типом атрибута.
 *
 * @param {Object} attribute
 * @param {*} value
 * @returns {*}
 */
export function formatHtml(attribute, value) {
    if (value != null && value !== '') {
        //noinspection NodeModulesDependencies,ES6ModulesDependencies
        switch (_.parseInt(attribute.type)) {
            case Accounting.AttributeType.Datetime:
                value = moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm');
                break;
            case Accounting.AttributeType.Date:
                value = moment(value, 'YYYY-MM-DD').format('DD.MM.YYYY');
                break;
            case Accounting.AttributeType.Checkbox:
                value = value ? 'Да' : 'Нет'
                break
            case Accounting.AttributeType.Counter:
                value = value.value;
                break;
            case Accounting.AttributeType.Dict:
                value = _.reduce(
                    _.map(value, (value) => {return _.get(value, 'value')}), (result, value) => {
                        return (result?', ':'')+value;
                    }, ''
                );
                break;
            case Accounting.AttributeType.Measuring:
            case Accounting.AttributeType.References:
            	if (!value.attributes) break;
                value = _.reduce(value, (result, value)=>{
                    return _.reduce(value.attributes, (result, value)=>{
                        if(typeof value === 'string') return result;
                        return _.reduce(value, (result, value)=>{
                            return (result.length?', ':'')+value.value;
                        },result)
                    },result)
                },{});
                break;
        }
    }

    return value;
}
/**
 * Конвертирует атрибуты в опции для рендеринга контролов
 *
 * @param {Object[]} attributes
 * @param {Object} [options]
 * @returns {Object[]}
 */
export function prepareControls(attributes, options = {}) {
    let setTitle = false;
    let featureMultiControl = null;

    options = {
        hideTitleAttribute: true,
        ...options
    };

    let controls = _(attributes)
        .map(attribute => {
            attribute.options = {
                [ Accounting.AttributeOption.TargetPrefix ]: 'item.attributes',
                [ Accounting.AttributeOption.HtmlPlaceholder ]: 'Укажите значение',
                ...(attribute.options || {})
            };

            //noinspection JSUnresolvedVariable
            if (attribute.options && attribute.options.isname && !setTitle && options.hideTitleAttribute) {
                setTitle = true;

                return false;
            }

            const formattedValue = format(attribute, attribute.value);
            const formattedHtmlValue = formatHtml(attribute, attribute.value);

            //noinspection NodeModulesDependencies,ES6ModulesDependencies,JSUnresolvedVariable
            let control = {
                ...Accounting.AttributeType.control(attribute.type),
                attribute: attribute.id,
                id: attribute.id,
                title: attribute.name,
                hidden: attribute.options && !!attribute.options.hidden || false,
                target: [ attribute.options[ Accounting.AttributeOption.TargetPrefix ], attribute.id ].join('.'),
                value: formattedValue,
                required: !!attribute.required,
                'mode': options.mode,
                "html-value": formattedHtmlValue,
                "html-name": `attribute_${attribute.id}`,
                'html-placeholder': attribute.options[ Accounting.AttributeOption.HtmlPlaceholder ],
                ...(attribute.options || {})
            };

			if (attribute.type === Accounting.AttributeType.Numeric
				&& attribute.alias && attribute.alias.includes('year')
			) {
				var value = attribute.value?attribute.value:(
					options.new?(new Date()).getFullYear():null
				);
				if (options.new) {
					control['def-value'] = (new Date()).getFullYear();
				}
				control.source = 'yearlist';
				control.type = 'select';
				control['show-empty'] = true;
			}

            //noinspection NodeModulesDependencies,ES6ModulesDependencies
            switch (_.parseInt(attribute.type)) {
                // handle dictionary attributes
                case Accounting.AttributeType.Dict:
                    attribute.options = {
                        [ Accounting.AttributeOption.DictRecordsSource ]: 'dictRecordsSource',
                        [ Accounting.AttributeOption.DictMasterIds ]: [],
                        ...(attribute.options || {})
                    };

                    if (attribute.options && attribute.options[ Accounting.AttributeOption.Dict ]) {
                        //noinspection JSUnresolvedVariable
                        const masterDictId = _.get(attribute, [ 'options', Accounting.AttributeOption.DictMasterIds, 0 ]);

                        //noinspection JSUnresolvedVariable
                        control = {
                            ...control,
                            source: attribute.options[ Accounting.AttributeOption.DictRecordsSource ],
                            target: [ attribute.options[ Accounting.AttributeOption.TargetPrefix ], attribute.id, 'refs' ].join('.'),
                            filter: JSON.stringify({ dictid: attribute.options[ Accounting.AttributeOption.Dict ] }),
                            master: masterDictId,
                            multiple: attribute.options[ Accounting.AttributeOption.Multiple ]
                        };
                    }
                    break;
                case Accounting.AttributeType.Feature:
                    // схлопываем все атрибуты Гео-объект в один супер мега контрол
                    featureMultiControl = pushFeatureMultiControl(featureMultiControl, control);
                    return null;
                case Accounting.AttributeType.Measuring:
                case Accounting.AttributeType.References:
                    //noinspection NodeModulesDependencies,ES6ModulesDependencies
                    attribute.options = {
                        [ Accounting.AttributeOption.ReferenceSource ]: 'referenceSource',
                        [ Accounting.AttributeOption.CreateReferenceHelper ]: 'createReferenceHelper',
                        [ Accounting.AttributeOption.AfterRenderCreateReferenceForm ]: 'afterRenderCreateReferenceForm',
                        [ Accounting.AttributeOption.ReferenceColumnsNum ]: 5,
                        [ Accounting.AttributeOption.ExcludedReferenceAttributeTypes ]: [
                            //Accounting.AttributeType.Dict,
                            Accounting.AttributeType.Feature,
                            Accounting.AttributeType.References,
                            Accounting.AttributeType.Measuring
                        ],
                        [ Accounting.AttributeOption.ReferenceAttributes ]: [],
                        ...(attribute.options || {})
                    };

                    if (attribute.options && attribute.options[ Accounting.AttributeOption.Kind ]) {
                        //noinspection JSUnresolvedVariable
                        control = {
                            ...control,
                            source: attribute.options[ Accounting.AttributeOption.ReferenceSource ],
                            target: [ attribute.options[ Accounting.AttributeOption.TargetPrefix ], attribute.id, 'refs' ].join('.'),
                            'create-reference-helper': attribute.options[ Accounting.AttributeOption.CreateReferenceHelper ],
                            'after-render-create-form': attribute.options[ Accounting.AttributeOption.AfterRenderCreateReferenceForm ],
                            // ищем простые атрибуты, добавленные в превью, в связанном типе учета
                            columns: (control.columns || [])
                                .concat(
                                    _.get(attribute, [ 'options', Accounting.AttributeOption.ReferenceAttributes ], [])
                                        .reduce((result, refAttribute) => {
                                            if (
                                                refAttribute.preview && !_.includes(attribute.options[ Accounting.AttributeOption.ExcludedReferenceAttributeTypes ], refAttribute.type)
                                            ) {
                                                let column = {
                                                    name: 'attributes.' + refAttribute.id,
                                                    title: refAttribute.name
                                                };
                                                //noinspection NodeModulesDependencies,ES6ModulesDependencies
                                                if (refAttribute.type == Accounting.AttributeType.Dict) {
                                                    //noinspection NodeModulesDependencies,ES6ModulesDependencies
                                                    column.type = Accounting.AttributeType.name(Accounting.AttributeType.Dict);
                                                }
                                                result.push(column);
                                            }

                                            return result;
                                        }, [])
                                )
                                .slice(0, attribute.options[ Accounting.AttributeOption.ReferenceColumnsNum ]),
                            filter: JSON.stringify({
                                kindid: attribute.options[ Accounting.AttributeOption.Kind ]
                            }),
                            multiple: attribute.options[ Accounting.AttributeOption.Multiple ]
                        };
                    }
                    break;
            }

            return control;
        })
        .filter()
        .value();

    if (featureMultiControl) {
        controls.push(featureMultiControl);
    }

    return controls;
}
export function isSortedColumn(attribute, options = {}) {
    if (_.includes([Accounting.AttributeType.Dict], attribute.type)) {
        return true;
    }

    return !!_.includes([ Accounting.AttributeType.Text, Accounting.AttributeType.Date, Accounting.AttributeType.Datetime, Accounting.AttributeType.Numeric, Accounting.AttributeType.TemplatedValue ], attribute.type);
}

export function prepareGridColumns(attributes, options = {}) {
    return _(attributes)
        .map(attribute => {
            if (!attribute.preview) return null;
            switch (attribute.type) {
                case Accounting.AttributeType.Dict:
                    return {
                        sorted: isSortedColumn(attribute),
                        name: "attributes." + attribute.id,
                        title: attribute.name,
                        type: 'Dict'
                    };
                    break;
                case Accounting.AttributeType.Counter:
                    return {
                        sorted: false,
                        name: "attributes." + attribute.id,
                        title: attribute.name,
                        type: 'Counter'
                    };
                    break;
                case Accounting.AttributeType.References:
                    return {
                        sorted: isSortedColumn(attribute),
                        name: "attributes." + attribute.id,
                        title: attribute.name,
                        type: 'Reference'
                    };
                    break;
				case Accounting.AttributeType.Cadastre:
					return {
						sorted: isSortedColumn(attribute),
						name: "attributes." + attribute.id,
						title: attribute.name,
						type: 'Cadastre'
					};
					break;
                default:
                    return {
                        sorted: isSortedColumn(attribute),
                        name: "attributes." + attribute.id,
                        title: attribute.name
                    };
                    break;
            }
        })
        .filter()
        .value()
}

export function prepareFilterControls (attributes, options = {}) {
    let controls = [];
    _.forEach(attributes, function(attribute) {
        if (!attribute.filter) return null;

        let control = {
            title: attribute.name,
            type: "text",
            //type: "xhr-autocomplete",
            //target: "filter.attributes."+attribute.id,
            //"html-name": "item.organizationname",
            //source: '/Accounting/Web/Tags/' + 'branch',
            //bind: "filter.tagid:id",
            //column: "name",
            //columns: "name"
        };

		let filterOptions = {};
        try {
			filterOptions = JSON.parse(_.get(attribute, 'options.filterOptions'))
		} catch(e){}


        switch (attribute.type) {
            case Accounting.AttributeType.Dict:
                _.merge(control, {
                    type: "xhr-autocomplete",
                    target: "filter.attributes_"+attribute.id,
                    source: '/Dict/Web/DynRecords/page',
					'data-source-options': {filter: {dictid: attribute.options.dict}},
                    bind: "filter[attributes]["+attribute.id+"]:id",
                    column: "value",
                    columns: "#{key}|value"
                }, filterOptions);
                controls.push(control);
                break;
            case Accounting.AttributeType.References:
                _.merge(control, {
					type: "xhr-autocomplete",
					target: "filter.attributes_" + attribute.id,
					source: '/Accounting/Web/Objects/page',
					'data-source-options': { filter: { kindid: attribute.options.kind } },
					bind: "filter[attributes][" + attribute.id + "]:id",
					column: "name",
					columns: "#{id}|{name}<br><span>{kindname}</span>"
				}, filterOptions);
                controls.push(control);
                break;
            case Accounting.AttributeType.Date:
                let controlClone = _.clone(control);
                _.merge(controlClone, {
					type: "datetimepicker",
					title: control.title + ' С',
					target: "filter[attributes][" + attribute.id + "][from]",
				}, filterOptions);
                controls.push(controlClone);

                controlClone = _.clone(control);
                _.merge(controlClone, {
					type: "datetimepicker",
					title: control.title + ' По',
					target: "filter[attributes][" + attribute.id + "][to]",
				}, filterOptions);
                controls.push(controlClone);
                break;
            default:
                _.merge(control, {
					target: "filter[attributes][" + attribute.id + "]",
				}, filterOptions);
                controls.push(control);
                break;
        }

    });
    return controls;
}

/**
 * @param multiControl
 * @param control
 * @returns {Object|Array|*}
 * @private
 */
function pushFeatureMultiControl(multiControl, control) {
    const field = [ 'id', 'uid', 'html-title', 'attribute', 'html-name', 'html-value',
        'layer', 'layername', 'target', 'value' ];

    control[ 'html-title' ] = control[ 'title' ];
    if (multiControl == null) {
        multiControl = _.clone(control);
        _.assign(multiControl, {
            type: "feature-multi",
            'title': 'Связанные геообъекты'
        });
    }

    multiControl = _.mapValues(multiControl, function (value, key) {
        if (_.includes(field, key)) {
            if (Array.isArray(value)) {
                value.push(_.clone(control[ key ]));
                return value;
            } else {
                return [ _.clone(control[ key ]) ];
            }
        } else {
            return value;
        }
    });

    return multiControl;
}
